import { useEffect, useState } from "react";
import axios from "axios";
import DynamicIcon from "../DynamicIcon";
import AppointmentCard from "../AppointmentCard";
import { getNodeApiUrl } from "../../config/api.config";

export default function JobCard({ job, accountId, token, apiBaseUrl }) {
    const [appointments, setAppointments] = useState([]);
    const [appointmentsLoading, setAppointmentsLoading] = useState(false);
    const [appointmentsError, setAppointmentsError] = useState(null);
    const [cloginsDetails, setCloginsDetails] = useState({});
    
    // Funzione per formattare le date
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        if (isNaN(date)) return '-';
        return new Intl.DateTimeFormat('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).format(date);
    };

    useEffect(() => {
        const fetchAppointments = async () => {
            setAppointmentsLoading(true);
            setAppointmentsError(null);
            try {
                const res = await axios.get(`${apiBaseUrl}/appointments/byJobId`, {
                    headers: { 'auth-token': token },
                    params: {
                        jobId: job._id,
                        accountId: accountId
                    }
                });
                const apps = res.data.data || [];
                setAppointments(apps);
                // Recupero cloginsDetails di tutti gli utenti coinvolti
                const userIds = Array.from(new Set(apps.flatMap(app => (app.users || []).map(u => u._id))));
                if (userIds.length > 0) {
                    const cloginsRes = await axios.get(`${apiBaseUrl}/users/cloginsDetails`, {
                        headers: { 'auth-token': token },
                        params: { userIds: userIds.join(",") }
                    });
                    // Mappa userId -> cloginsDetails
                    const cloginsMap = {};
                    (cloginsRes.data.data || []).forEach(u => {
                        cloginsMap[u._id] = u.cloginsDetails;
                    });
                    setCloginsDetails(cloginsMap);
                }
            } catch (err) {
                setAppointmentsError("Errore nel recupero appuntamenti o cloginsDetails");
            }
            setAppointmentsLoading(false);
        };
        fetchAppointments();
        // eslint-disable-next-line
    }, [job._id, accountId, token, apiBaseUrl]);

    // Le funzioni di formattazione date sono state spostate nel componente AppointmentCard
    
    // Le funzioni di gestione note e download allegati sono state spostate nel componente AppointmentCard
    
    // Le funzioni di gestione file e allegati sono state spostate nel componente AppointmentCard
    
    // Estrae l'ID del file dall'URL o restituisce l'ID stesso
    const getFileId = (fileUrl) => {
        if (!fileUrl) return '';
        // Se è un URL Google Storage, estrae il nome del file dalla fine dell'URL
        if (fileUrl.includes('storage.googleapis.com')) {
            const parts = fileUrl.split('/');
            return parts[parts.length - 1];
        }
        return fileUrl;
    };

    return (
        <div className="bg-white rounded-lg shadow p-4 flex flex-col gap-2 border border-gray-200">
            <div className="flex flex-col gap-1">
                <div className="font-bold text-lg text-green-900">{job.code}</div>
                <div className="text-sm text-green-700 font-semibold">{job.statusLabel}</div>
            </div>
            <div className="grid grid-cols-2 gap-1 text-sm">
                <div><strong>Cliente:</strong> {job.customerLabel || '-'}</div>
                <div><strong>Descrizione:</strong> {job.description || '-'}</div>
                <div><strong>Creata:</strong> {formatDate(job.creationDate)}</div>
                <div><strong>Scadenza:</strong> {formatDate(job.expirationDate)}</div>
                <div><strong>Tipo commessa:</strong> {job.jobTypeLabel || '-'}</div>
                <div><strong>Importo:</strong> {job.amount ? job.amount + ' €' : '-'}</div>
            </div>
            <div className="mt-2">
                <div className="font-semibold text-green-800 mb-1 text-base">Appuntamenti collegati</div>
                {appointmentsLoading && <div className="text-sm text-gray-600">Caricamento appuntamenti...</div>}
                {appointmentsError && <div className="text-sm text-red-500">{appointmentsError}</div>}
                {appointments.length === 0 && !appointmentsLoading && (
                    <div className="text-sm text-gray-400">Nessun appuntamento collegato</div>
                )}
                {appointments.length > 0 && (
                    <ul className="flex flex-col gap-1">
                        {[...appointments]
                            .sort((a, b) => (a.fromDate || 0) - (b.fromDate || 0))
                            .map(app => (
                                <li key={app._id}>
                                    <AppointmentCard 
                                        appointment={app} 
                                        token={token} 
                                        apiBaseUrl={apiBaseUrl} 
                                    />
                                </li>
                            ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
